const Cypress = ({ width = '24', height = '24', className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      {...rest}
    >
      <circle
        cx="12.4258"
        cy="12"
        r="11.25"
        fill="white"
        stroke="#CBCBCB"
        stroke-width="0.5"
      />
      <g opacity="0.55">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9181 9.12221C10.6133 8.99519 10.2322 8.94439 9.82571 8.94439V8.94434C9.24145 8.94434 8.73337 9.09679 8.3015 9.32546C7.86958 9.60493 7.51394 9.98594 7.28533 10.494C7.05665 10.9767 6.92969 11.561 6.92969 12.1961C6.92969 12.8566 7.05665 13.4155 7.28533 13.8982C7.51394 14.3809 7.86958 14.7619 8.3015 15.016C8.75873 15.27 9.26682 15.397 9.87656 15.397C10.6387 15.397 11.2992 15.1684 11.8834 14.6857L11.1722 13.6696C10.9181 13.822 10.7149 13.9236 10.537 13.9998C10.3592 14.076 10.156 14.1014 9.95273 14.1014C9.52087 14.1014 9.21603 13.9744 8.98741 13.6696C8.75873 13.3901 8.65714 12.9074 8.65714 12.2215C8.65714 10.8751 9.089 10.2146 9.95273 10.2146C10.156 10.2146 10.3847 10.24 10.5625 10.3162C10.7403 10.3924 10.9435 10.494 11.1468 10.6465L11.8581 9.6811C11.5532 9.42705 11.2484 9.24924 10.9181 9.12221ZM14.7808 17.0735C15.3143 16.6417 15.6954 16.0574 15.9494 15.2698H15.9495L17.931 9.17285H16.2289L14.9332 14.2282L13.7139 9.17285H11.9609L14.0695 15.9304C14.0695 15.9304 13.8663 16.159 13.7647 16.2352C13.4852 16.4385 13.0533 16.5655 12.4691 16.6417L12.6469 17.8103C13.536 17.7341 14.2474 17.5054 14.7808 17.0735Z"
          fill="#05010C"
        />
      </g>
    </svg>
  );
};

export default Cypress;
